import { MentorshipProposalApi } from "../Api/apis";
import { getAuthConfiguration } from "./configuration";
import { arrayParamAjust } from "../utils/dataUtils";

const AuthMentorshipProposalApiFactory = () =>
	new MentorshipProposalApi(getAuthConfiguration());

interface AllMentorshipPropsalsProps {
	searchTerm?: string;
	Company?: Array<string>;
	Faculty?: Array<string>;
	page?: number;
	pageSize?: number;
}

export const getAllMentorshipPropsals = (props: AllMentorshipPropsalsProps) => {
	const {
		searchTerm,
		Company: companies,
		Faculty: faculties,
		page,
		pageSize,
	} = props;

	return AuthMentorshipProposalApiFactory().apiMentorshipProposalGetAllGet({
		searchTerm,
		companies: arrayParamAjust(companies),
		faculties,
		page,
		pageSize,
	});
};

export const getMentorshipProposalById = (id: string) => {
	return AuthMentorshipProposalApiFactory().apiMentorshipProposalGetByIdIdGet({
		id,
	});
};

export const getMentorshipsProposalFilters = () => {
	return AuthMentorshipProposalApiFactory().apiMentorshipProposalGetMentorshipsProposalFiltersGet();
};
